import { render, staticRenderFns } from "./threejs10.vue?vue&type=template&id=5d2d47a2&scoped=true"
import script from "./threejs10.vue?vue&type=script&lang=js"
export * from "./threejs10.vue?vue&type=script&lang=js"
import style0 from "./threejs10.vue?vue&type=style&index=0&id=5d2d47a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d47a2",
  null
  
)

export default component.exports